export const SECURITYQUESTIONS = [
  'What is your favorite book?',
  'What is the name of the road you grew up on?',
  "What is your mother's maiden name?",
  'What was the first company that you worked for?',
  'Where did you meet your spouse?',
  'Where did you go to high school/college?',
  'What is the name of your first pet?',
  'What was your first car?',
  'What elementary school did you attend?',
];
